<template>
	<div>
		<!-- 物料弹框 -->
		<!--<pickp :isVisible="itevisible" @getitembomp="pick" ref="input"></pickp>-->
		<selector :isVisible="itevisible" :isSplitPage=true :postUrl="'/Eng/Boms/GetBomParentPartList'" @callback="pick" ref="input"></selector>
		<!--<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span>{{ $t('getapi[930]') }}</span>
			</div>
			<el-form :model="olditem" label-width="40px" :inline="true">

				<el-form-item :label="$t('getapi[112]')"><el-input v-model="olditem.part_code" v-on:click.native="showitem"  suffix-icon="el-icon-edit" readonly></el-input></el-form-item>
				<el-form-item :label="$t('getapi[116]')"><el-input v-model="olditem.part_name" disabled></el-input></el-form-item>
				<el-form-item :label="$t('getapi[149]')"><el-input v-model="olditem.part_version" disabled></el-input></el-form-item>
				<el-form-item :label="$t('getapi[121]')"><el-input v-model="olditem.dummy_flag" disabled></el-input></el-form-item>
				<el-form-item :label="$t('getapi[6005]')"><el-switch v-model="allshow" @change="allshows"></el-switch></el-form-item>
			</el-form>
		</el-card>-->
		<!-- <el-row style=" margin: 20px auto;background: white;padding: 10px 20px 5px; line-height: 30px;">
			<el-col :span="24">
				<el-divider content-position="left">{{ $t('getapi[930]') }}</el-divider>
				<el-form :model="olditem" label-width="80px" :inline="true">
					<el-form-item :label="$t('getapi[112]')"><el-input v-model="olditem.part_code" v-on:click.native="showitem"  suffix-icon="el-icon-edit"></el-input></el-form-item>
					<el-form-item :label="$t('getapi[116]')"><el-input v-model="olditem.part_name" disabled></el-input></el-form-item>
					<el-form-item :label="$t('getapi[149]')"><el-input v-model="olditem.part_version" disabled></el-input></el-form-item>
					<el-form-item :label="$t('getapi[121]')"><el-input v-model="olditem.dummy_flag" disabled></el-input></el-form-item>
					<el-form-item :label="$t('getapi[6005]')"><el-switch v-model="allshow" @change="allshows"></el-switch></el-form-item>
				</el-form>
			</el-col>
		</el-row> -->
		<table>
			<tr>
				<td colspan="9">
					<el-divider content-position="left">{{ $t('getapi[930]') }}</el-divider>
				</td>
			</tr>
			<tr>
				<td style="width:60px">
					{{$t('getapi[112]')}}
				</td>
				<td style="width:150px">
					<routejump :urlNo="12">
						<el-input v-model="olditem.part_code" v-on:click.native="showitem"  suffix-icon="el-icon-edit" readonly></el-input>
					</routejump>
				</td>
				<td style="width:60px">
					{{$t('getapi[116]')}}
				</td>
				<td style="width:150px">
					<el-input v-model="olditem.part_name" disabled></el-input>
				</td>
				<td style="width:60px">
					{{$t('getapi[149]')}}
				</td>
				<td style="width:50px">
					<el-input v-model="olditem.part_version" disabled></el-input>
				</td>
				<td style="width:60px">
					{{$t('getapi[133]')}}
				</td>
				<td style="width:180px">
					<el-input v-model="olditem.page_no" disabled></el-input>
				</td>
				
				<td style="width:80px">
					<el-checkbox v-model="olditem.dummy_flag" disabled :true-label="$t('getapi[561]')" :false-label="$t('getapi[866]')"
					>{{ $t('getapi[121]')}}</el-checkbox>
				</td>
				<td style="width:60px">
					{{$t('getapi[6005]')}}
				</td>
				<td>
					<el-switch v-model="allshow" @change="allshows"></el-switch>
				</td>
			</tr>
		</table>
		<el-tabs>
			<el-tab-pane :label="$t('getapi[6003]')">
				<vxe-table
					:data="datajson"
					v-loading="loading"
					:highlight-current-row="false"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					:height="tableHeight"
					tab-click="selectInfo(0)"
					header-row-class-name="headerclass"
					@selection-change="handleSelectionChange"
					style="width: 100%; margin-top:0px"
					ref="singleTable"
				>
					<vxe-table-column show-overflow-tooltip v-for="item in BomUpColumns" :key="item.index" :field="item.ColumnsField" :title="item.ColumnsName" width="150"></vxe-table-column>
				</vxe-table>
			</el-tab-pane>
			<el-tab-pane :label="$t('getapi[6004]')">
				
				<el-table
					v-if="refreshTable"
					:data="datajsontree"
					style="width: 100%;margin-bottom: 20px;"
					border
					:default-expand-all="allshow"
					size="mini"
					header-row-class-name="headerclass"
					:height="tableHeight"
					row-key="guid"
					:tree-props="{ children: 'Children', hasChildren: 'hasChildren' }"
					ref="singleTable1"
				>
					<el-table-column prop="guid" label="" width="100">
						<template>
							<i class="el-icon-tickets"></i>
						</template>
					</el-table-column>
					<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[930]')" width="150"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" width="150"></el-table-column>
					<el-table-column show-overflow-tooltip prop="dummy" :label="$t('getapi[6117]')" width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_Name" :label="$t('getapi[116]')" width="150"></el-table-column>
					<el-table-column show-overflow-tooltip prop="page_no" :label="$t('getapi[133]')" width="150"></el-table-column>
				</el-table>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
export default {
	name:'reverses',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight- 200
        }
    },
	data() {
		return {
			itevisible: false,
			radio: 1,
			datajson: [],
			datajsontree: [],
			BomUpColumns: [],
			allshow: false,
			refreshTable :true,
			selectIDData: '',
			olditem: {
				Column1: '',
				Column2: '',
				id: '',
				part_code: '',
				part_version: '',
				page_no:''
			},
			newitem: {
				part_CODE: '',
				part_NAME: '',
				part_version: '',
				item_code: ''
			},
			loading: false, // 主表加载状态
            scrollTop:0,
            scrollTop1:0,
		};
	},
	mounted: function() {
		let that = this;
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
            that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop1 = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
            }, 13)
        })

    },
	methods: {
		// 展示关闭所有
		allshows(e) {
			this.allshow = e;
			this.refreshTable = false;
			this.$nextTick(() => {
				this.refreshTable = true;
			});
		},
		//打开物料选择框
		showitem() {
			console.log('hello');
			this.itevisible = true;
			this.$refs.input.clearInput(this.itevisible);
		},
		//获取物料信息
		pick(val) {
			console.log(val);
			this.olditem = val;
			this.getbomrevers();
		},
		//bom反向遍历查询
		getbomrevers() {
			let that = this;
			that.loading = true;
			let parm = {
				id: that.olditem.part_id
			};
			console.log(parm);
			that.$http.urlpost('Eng/Boms/GetBomReverseTQuery', parm, res => {
				console.log(res);
				if (res.Success == 1) {
					that.datajson = res.DataContent.BomPartUp;
					that.datajsontree = res.DataContent.BomTreeUp;
                    that.tickMenuIdFilter().filter(that.datajsontree)
					console.log(that.datajsontree)
                    /*for(let i =0;i<that.datajsontree.length;i++){
                        that.datajsontree[i].hasChildren = true
                    }*/
					that.BomUpColumns = res.DataContent.BomUpColumns;
				}
				that.loading = false;
			});
		},
        // 解析数组
        tickMenuIdFilter: function() {
            let that = this
            let getTickMenuId = function(obj) {
                if (obj.Children.length != 0) {
                    obj.hasChildren = true
                }
                if (null != obj.Children && obj.Children.length != 0) {
                    for (let child of obj.Children) {
                        getTickMenuId(child);
                    }
                }
            };
            return {
                filter: function(arr) {
                    if (arr.length == 0) {
                        return false;
                    }
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return that.datajsontree
                }
            };
        },
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Exclusively_Id + ',';
			}
			console.log(that.selectIDData);
		}
	}
};
</script>

<style scoped lang="less">
	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
	td {
		padding-left: 3px;
	}
	}
</style>
